export class DocumentType {
  documentTypeId: number;
  name: string;
  description: string;
  isPrimaryDocument: boolean;
}
